import { render, staticRenderFns } from "./distrilistbute.vue?vue&type=template&id=321271b2"
import script from "./distrilistbute.vue?vue&type=script&lang=js"
export * from "./distrilistbute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports